import script from "./ProjectCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCategory.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCategory.vue?vue&type=style&index=0&id=cb18b412&lang=css"

const __exports__ = script;

export default __exports__